<template>
  <div class="dropdown" :class="{ dropdown_visible: isVisible }">
    <a @click="goToProfile" class="dropdown__item" v-if="system_status === 40"
      >Профиль</a
    >
    <a class="dropdown__item" v-if="system_status === 40">Настройки</a>
    <a @click="userLogout" class="dropdown__item">Выйти</a>
  </div>
</template>

<script>
import auth from "@/helpers/auth";
import { mapState } from "vuex";
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState({
      system_status: state => state.user.systemStatus
    })
  },
  methods: {
    // Выход пользователя
    userLogout() {
      this.$store.dispatch("userLogout").finally(() => {});
      // auth.checkUserAuthorization(this.$router, this.$store);
    },
    goToProfile() {
      this.$router.push("/profile");
    }
  }
};
</script>

<style scoped>
.dropdown {
  display: none;
  border-radius: 5px;
  background-color: #ffffff;
  list-style: none;
  flex-direction: column;
}

.dropdown_visible {
  display: flex;
}

.dropdown__item {
  padding: 10px 15px;
  font-size: 15px;
  color: #000000;
  cursor: pointer;
}

.dropdown__item:first-child {
  border-radius: 5px 5px 0 0;
}

.dropdown__item:last-child {
  border-radius: 0 0 5px 5px;
}

.dropdown__item:hover {
  color: #2e79ef;
  background-color: #dfe1e5;
}
</style>
